import { AxiosError } from 'axios';
import api from '../../../services/api';
import { SubareaFormProps } from '../types/subarea.type';

export async function createSubareaRequest({ areaId, name }: SubareaFormProps) {
	try {
		const response = await api.post('/sub-area', {
			areaId,
			name,
		});

		return response.data;
	} catch (error) {
		if (error instanceof AxiosError) {
			throw new Error(error.response?.data?.message);
		} else {
			throw new Error();
		}
	}
}
